import Urls from "../../api/endpoints";
import { Paging } from "../../shared/index";
import SearchForm from "./parts/search/form";
import { useNavigate } from "react-router-dom";
import SearchTable from "./parts/search/table";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import { NidInquiryStatusType } from "../../enums/index";
import React, { useState, useEffect, useRef } from "react";
import { ErrorHandling, ErrorHandlingAPI } from "../../functions";
const Search = (props) => {
  const navigate = useNavigate();
  const filterSearchTriggered = useRef(false);
  const [filter, setFilter] = useState(props.searchFilter);
  const [conditions, setConditions] = useState(
    props.searchTerm !== "" ? [props.searchTerm] : []
  );
  const [dropDownFilter, setDropDownFilter] = useState(
    Constants.SearchDropDownItemsText(props.searchFilter)
  );
  const [emptySearch, setEmptySearch] = useState(
    props.searchTerm !== "" ? true : false
  );
  const [showInquireDate, setShowInquireDate] = useState(false);
  const [showAuthDate, setShowAuthDate] = useState(false);
  function changeBackground(e) {
    e.currentTarget.className = "hovered";
  }
  function changeBackgroundBack(e) {
    e.currentTarget.className = "";
  }
  const goToUserPage = async (uri) => {
    navigate(`/${uri}`);
  };
  const emptySearchInput = () => {
    setEmptySearch(false);
    props.searchedText.current.value = "";
    searchInputChange();
  };
  const [heading, setHeading] = useState(
    props.searchFilter.includes(NidInquiryStatusType.ReadyForInquiry()) ||
      props.searchFilter.includes(NidInquiryStatusType.InProgress())
      ? Headings.SearchTableHeadingInReady
      : Headings.SearchTableHeading
  );
  const [criterial, setCriterial] = useState({
    Conditions: conditions,
    NidInquiryStatuses: filter,
    PageSize: Constants.searchPagesLength,
    PageIndex: props.selectedPageIndex,
    SendCountResult: true,
  });
  const whenEmptyOrError = async () => {
    props.setSearchData({
      CustomerSearchResult: [],
      CountCustomerSearchResult: 0,
    });
    props.setShowSpinner(false);
    props.setSearch(false);
    props.setSelectedPageIndex(1);
    props.setSearchPages([]);
    props.setUserId(null);
  };
  const searchInputChange = (e = null) => {
    if (e) e.preventDefault();
    if (props.searchedText.current.value !== "") {
      setEmptySearch(true);
    } else {
      setEmptySearch(false);
    }
    setConditions(props.searchedText.current.value.split(" "));
    setCriterial({
      Conditions: conditions,
      NidInquiryStatuses: filter,
      PageSize: Constants.searchPagesLength,
      PageIndex: props.selectedPageIndex,
      SendCountResult: true,
    });
    props.setSearchTerm(props.searchedText.current.value);
  };
  const setFilterValue = async (value) => {
    switch (value) {
      case 0:
        whenEmptyOrError();
        setFilter([NidInquiryStatusType.All()]);
        props.setSearchFilter([NidInquiryStatusType.All()]);
        break;
      case 1:
        whenEmptyOrError();
        setFilter([NidInquiryStatusType.Accepted()]);
        props.setSearchFilter([NidInquiryStatusType.Accepted()]);
        break;
      case 2:
        whenEmptyOrError();
        setFilter([
          NidInquiryStatusType.ReadyForInquiry(),
          NidInquiryStatusType.InProgress(),
        ]);
        props.setSearchFilter([
          NidInquiryStatusType.ReadyForInquiry(),
          NidInquiryStatusType.InProgress(),
        ]);

        doTheSearch(null, {
          Conditions: [props.searchTerm],
          NidInquiryStatuses: [
            NidInquiryStatusType.ReadyForInquiry(),
            NidInquiryStatusType.InProgress(),
          ],
          PageSize: Constants.searchPagesLength,
          PageIndex: props.selectedPageIndex,
          SendCountResult: true,
        });
        break;
      case 3:
        whenEmptyOrError();
        setFilter([NidInquiryStatusType.Rejected()]);
        props.setSearchFilter([NidInquiryStatusType.Rejected()]);
        break;
      default:
        whenEmptyOrError();
        setFilter([NidInquiryStatusType.All()]);
        props.setSearchFilter([NidInquiryStatusType.All()]);
        break;
    }
  };
  const doTheSearch = (e, passedCriterial = criterial) => {
    if (e) e.preventDefault();
    props.setShowSpinner(true);
    if (passedCriterial.Conditions.length > 0) {
      if (passedCriterial.Conditions[0] === "") passedCriterial.Conditions = [];
    }
    fetch(Urls.searchWithCriterial(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(passedCriterial),
    })
      .then((response) => response.json())
      .then((data) => {
        props.setShowSpinner(false);
        if (data.Success) {
          if (passedCriterial.SendCountResult) {
            props.setSearchPages([]);
            for (
              let index = 1;
              index <
              data.CountCustomerSearchResult / Constants.searchPagesLength + 1;
              index++
            ) {
              props.setSearchPages((searchPages) => [...searchPages, index]);
            }
          }
          if (
            passedCriterial.NidInquiryStatuses.includes(
              NidInquiryStatusType.ReadyForInquiry()
            ) ||
            passedCriterial.NidInquiryStatuses.includes(
              NidInquiryStatusType.InProgress()
            )
          ) {
            setHeading(Headings.SearchTableHeadingInReady);
            data.CustomerSearchResult.sort(function (a, b) {
              return new Date(b.ReadyDate) - new Date(a.ReadyDate);
            });
            props.setSearchData(data);
            setShowAuthDate(true);
            setShowInquireDate(false);
          } else if (
            passedCriterial.NidInquiryStatuses.includes(
              NidInquiryStatusType.Accepted()
            )
          ) {
            setHeading(Headings.SearchTableHeadingInAccepted);
            data.CustomerSearchResult.sort(function (a, b) {
              return (
                new Date(b.AcceptedInquireDate) -
                new Date(a.AcceptedInquireDate)
              );
            });
            props.setSearchData(data);
            setShowAuthDate(true);
            setShowInquireDate(true);
          } else {
            props.setSearchData(data);
            setHeading(Headings.SearchTableHeading);
            setShowAuthDate(false);
            setShowInquireDate(false);
          }
        } else {
          whenEmptyOrError();
          ErrorHandlingAPI(data);
        }
      })
      .catch((error) => {
        whenEmptyOrError();
        ErrorHandling(error, "search error");
      });
  };
  const setInReadyHeading = () => {
    setHeading(Headings.SearchTableHeadingInReady);
    setShowAuthDate(true);
  };
  const setAcceptedHeading = () => {
    setShowAuthDate(true);
    setShowInquireDate(true);
    setHeading(Headings.SearchTableHeadingInAccepted);
  };
  useEffect(() => {
    if (
      (filter.includes(NidInquiryStatusType.ReadyForInquiry()) ||
        filter.includes(NidInquiryStatusType.InProgress())) &&
      !filterSearchTriggered.current
    ) {
      doTheSearch(null, {
        Conditions: [props.searchTerm],
        NidInquiryStatuses: filter,
        PageSize: Constants.searchPagesLength,
        PageIndex: 1,
        SendCountResult: true,
      });
      setInReadyHeading();
      filterSearchTriggered.current = true;
    }
    if (
      filter.includes(NidInquiryStatusType.Accepted()) &&
      !filterSearchTriggered.current
    ) {
      setAcceptedHeading();
      filterSearchTriggered.current = true;
    }
  });
  return (
    <>
      <div className="top-margin"></div>
      <div className="search-container mb-5 pb-3">
        <SearchForm
          filter={filter}
          conditions={conditions}
          emptySearch={emptySearch}
          doTheSearch={doTheSearch}
          dropDownItems={Constants.SearchDropDownItems}
          searchTerm={props.searchTerm}
          showSpinner={props.showSpinner}
          dropDownFilter={dropDownFilter}
          setFilterValue={setFilterValue}
          searchedText={props.searchedText}
          emptySearchInput={emptySearchInput}
          setDropDownFilter={setDropDownFilter}
          searchInputChange={searchInputChange}
          selectedPageIndex={props.selectedPageIndex}
        ></SearchForm>
        <SearchTable
          heading={heading}
          setSearch={props.setSearch}
          setUserId={props.setUserId}
          goToUserPage={goToUserPage}
          searchData={props.searchData}
          changeBackground={changeBackground}
          changeBackgroundBack={changeBackgroundBack}
          showAuthDate={showAuthDate}
          showInquireDate={showInquireDate}
        ></SearchTable>
        <Paging
          filter={filter}
          criterial={criterial}
          conditions={conditions}
          doTheSearch={doTheSearch}
          setCriterial={setCriterial}
          searchData={props.searchData}
          searchPages={props.searchPages}
          selectedPageIndex={props.selectedPageIndex}
          setSelectedPageIndex={props.setSelectedPageIndex}
        ></Paging>
      </div>
    </>
  );
};
export default Search;
